import React from 'react';
import { NavLink } from 'react-router-dom';
import { Activity, AlertOctagon, ArrowRightLeft, BarChart3, Car, ClipboardCheck, CloudDownload, FileClock, FilePlus as FilePlus2, GitBranch, LayoutDashboard, Link2, Network, Printer, QrCode, RefreshCcw, Route, ScrollText, ShieldCheck, Sticker, Truck, UserCog, Users } from 'lucide-react';
import { DmpLogo } from '../brand/DmpLogo';
const groups = [{
  title: 'ড্যাশবোর্ড',
  items: [{
    to: '/admin',
    label: 'এক্সিকিউটিভ ড্যাশবোর্ড',
    icon: LayoutDashboard,
    end: true
  }, {
    to: '/admin/monitoring',
    label: 'রোডসাইড মনিটরিং',
    icon: Activity
  }]
}, {
  title: 'তথ্য ব্যবস্থাপনা',
  items: [{
    to: '/admin/cng',
    label: 'যানবাহন তথ্য',
    icon: Car,
    end: true
  }, {
    to: '/admin/cng/new',
    label: 'নতুন গাড়ির তথ্য',
    icon: FilePlus2
  }, {
    to: '/admin/drivers',
    label: 'চালক ব্যবস্থাপনা',
    icon: Users
  }, {
    to: '/admin/assignment/c1',
    label: 'চালক সংযুক্তকরণ',
    icon: Link2
  }]
}, {
  title: 'যাচাই ও অনুমোদন',
  items: [{
    to: '/admin/validation',
    label: 'তথ্য যাচাই',
    icon: ClipboardCheck
  }, {
    to: '/admin/approval',
    label: 'অনুমোদন প্রক্রিয়া',
    icon: GitBranch
  }]
}, {
  title: 'QR স্টিকার',
  items: [{
    to: '/admin/qr',
    label: 'QR স্টিকার তৈরি',
    icon: QrCode
  }, {
    to: '/admin/printing',
    label: 'প্রিন্ট ব্যবস্থাপনা',
    icon: Printer
  }, {
    to: '/admin/issue',
    label: 'স্টিকার ইস্যু',
    icon: Sticker
  }, {
    to: '/admin/replacement',
    label: 'স্টিকার প্রতিস্থাপন',
    icon: RefreshCcw
  }]
}, {
  title: 'নজরদারি ও রিপোর্ট',
  items: [{
    to: '/admin/irregularities',
    label: 'অনিয়ম ব্যবস্থাপনা',
    icon: AlertOctagon
  }, {
    to: '/admin/reports',
    label: 'রিপোর্ট',
    icon: BarChart3
  }]
}, {
  title: 'BRTA',
  items: [{
    to: '/admin/brta-import',
    label: 'BRTA তথ্য আমদানি',
    icon: CloudDownload
  }, {
    to: '/admin/brta-api',
    label: 'BRTA API (ভবিষ্যৎ)',
    icon: Network
  }]
}, {
  title: 'প্রশাসন',
  items: [{
    to: '/admin/users',
    label: 'ইউজার ও রোল',
    icon: UserCog
  }, {
    to: '/admin/audit',
    label: 'অডিট লগ',
    icon: FileClock
  }]
}, {
  title: 'প্রক্রিয়া চিত্র',
  items: [{
    to: '/admin/stickers',
    label: 'স্টিকার ডিজাইন ও স্থাপন',
    icon: ScrollText
  }, {
    to: '/admin/process',
    label: 'স্টিকার ইস্যু প্রক্রিয়া',
    icon: ArrowRightLeft
  }, {
    to: '/admin/journey',
    label: 'রোডসাইড যাচাই যাত্রা',
    icon: Route
  }, {
    to: '/admin/expansion',
    label: 'ভবিষ্যৎ সম্প্রসারণ',
    icon: Truck
  }]
}];
export function AdminSidebar() {
  return <aside className="print-hide sticky top-12 hidden h-[calc(100vh-48px)] w-64 shrink-0 flex-col bg-sidebar text-sidebar-foreground lg:flex" data-id="element-97" data-mp="t6zflf4mn7vn">
      <div className="flex items-center gap-3 border-b border-sidebar-border px-4 py-4" data-id="element-98" data-mp="y2ojtvrldcya">
        <DmpLogo size={40} data-id="element-99" data-mp="k7cqnst33ujh" />
        <div className="leading-tight" data-id="element-100" data-mp="p435kct5kk3b">
          <p className="text-sm font-semibold" data-id="element-101" data-mp="p31i18uya54p">ঢাকা মেট্রোপলিটন পুলিশ</p>
          <p className="text-[11px] text-navy-200" data-id="element-102" data-mp="5i19uzm53nho">যানবাহন ও চালক যাচাই ব্যবস্থাপনা</p>
        </div>
      </div>
      <nav className="no-scrollbar flex-1 overflow-y-auto px-2.5 py-3" aria-label="অ্যাডমিন মেনু" data-id="element-103" data-mp="k9f7xu41n9s">
        {groups.map(g => <div key={g.title} className="mb-3" data-id="element-104" data-mp="ekkb5faa1s1t">
            <p className="px-2 pb-1 text-[10px] font-semibold uppercase tracking-wider text-navy-300" data-id="element-105" data-mp="ah4g2nduvzr8">{g.title}</p>
            <ul data-id="element-106" data-mp="ognakddqvcl2">
              {g.items.map(({
            to,
            label,
            icon: Icon,
            end
          }) => <li key={to} data-id="element-107" data-mp="jiu5xos3aqmw">
                  <NavLink to={to} end={end} className={({
              isActive
            }) => `flex items-center gap-2.5 rounded-md px-2.5 py-[7px] text-[13px] transition ${isActive ? 'bg-white font-semibold text-navy-900' : 'text-navy-100 hover:bg-sidebar-accent hover:text-white'}`} data-id="element-108" data-mp="jhj4vwq13wzh">
                    <Icon className="h-4 w-4 shrink-0" strokeWidth={1.8} data-id="element-109" data-mp="126z48gpz9jeb" />
                    {label}
                  </NavLink>
                </li>)}
            </ul>
          </div>)}
      </nav>
      <div className="flex items-center gap-2 border-t border-sidebar-border px-4 py-3 text-[11px] text-navy-200" data-id="element-110" data-mp="36f3lf54s6kso">
        <ShieldCheck className="h-4 w-4 text-bdgreen-200" data-id="element-111" data-mp="3agyoof69v893" />
        নিরাপদ সংযোগ • DMP Data Center
      </div>
    </aside>;
}